import { render, staticRenderFns } from "./CourseOverview.vue?vue&type=template&id=63e3d80a&scoped=true"
import script from "./CourseOverview.vue?vue&type=script&lang=js"
export * from "./CourseOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e3d80a",
  null
  
)

export default component.exports